import { COLORS } from '@app/constants';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { View } from '@/styles/reactnative';
import { CButton } from '../Common';
import styled from 'styled-components';

const AuthCheckBtns = () => {
  const { t } = useTranslation();
  const navigation = useNavigate();
  return (
    <View
      style={{
        width: '100%',
        flexDirection: 'row',
        gap: 8,
        padding: 12,
      }}
    >
      <CustomButton
        style={{
          background: '#07d993',
          color: '#0d1117',
        }}
        onClick={() => {
          navigation('/signup');
        }}
      >
        {t('signUp')}
      </CustomButton>

      <CustomButton
        onClick={() => {
          navigation('/login');
        }}
      >
        {t('login')}
      </CustomButton>
    </View>
  );
};

export default AuthCheckBtns;

const CustomButton = styled.button`
  border: none;
  background: #2a2c2e;
  color: #e9e9ed;
  height: 42px;
  width: 100%;
  border-radius: 6px;
  box-sizing: border-box;
  flex: 1;
  font-family: 'NanumSquareRound';
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.36px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #06c585;
    transform: translateY(-1px);
    box-shadow: 0px 2px 12px 0px rgba(7, 217, 147, 0.6);
  }
`;
